import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen, IsXsScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const DashboardHelp = () => {
  const isMdScreen = IsMdScreen();
  const paddingValue = IsXsScreen() ? 1 : 3;

  return (
    <>
      <Stack padding={paddingValue} direction={"row"}>
        <ShContainer maxWidth='xl' margin='auto'>
          <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
            Dashboard Overview
          </ResourceTypography>
          <ResourceTypography variant="body1" paragraph>
            Your dashboard is the central hub for managing your hiring process. Here you can monitor
            key metrics, access important features, and stay updated on your recruitment activities.
          </ResourceTypography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Key Metrics
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            View important hiring metrics at a glance, including active job postings, applications received,
            interviews scheduled, and more. These metrics help you track your hiring progress.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Quick Actions
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Access frequently used features directly from your dashboard. Create new job postings,
            review applications, schedule interviews, and manage your hiring pipeline efficiently.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Recent Activity
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Stay informed about recent activities in your hiring process. Track new applications,
            interview updates, and important notifications all in one place.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Customization
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Customize your dashboard to show the information most relevant to you. Arrange widgets,
            set preferences, and create a personalized view that matches your workflow.
          </Typography>

          <Box paddingTop={2} paddingBottom={3}>
            <ShButton
              component={RouterLink}
              to="/employer/dashboard"
              color="primary"
              variant="contained"
            >
              Go to Dashboard
            </ShButton>
          </Box>
        </ShContainer>
        {!isMdScreen && <CommonQuestionSidebar />}
      </Stack>
    </>
  );
};

export default DashboardHelp; 